import { Injectable } from '@angular/core';

import { environment } from '@app/environment';

import { LoggedUser } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class LoggedUserService {
    
    loggedUser: LoggedUser|null = null;
    jwtToken: string|null;
       
    constructor() { }
    
    setLoggedUser(json: any){
        this.loggedUser = LoggedUser.FromJson(json);
    }
    
    resetLoggedUser(){
        this.loggedUser = null;
        this.jwtToken = null;
    }
}
